/** Abbreviations that stay in capitals when a stored code is written out as words. */
const ABBREVIATIONS = new Set(['DDTL', 'PIK', 'SOFR', 'LIBOR', 'TLA', 'TLB', 'TL', 'RCF', 'ABL', 'PE', 'LLC', 'LP', 'USD', 'EUR', 'GBP']);

/** A stored code such as FIRST_LIEN as an operator reads it: "First lien". Anything else is left as written. */
export const plainCode = (value: string | null | undefined): string => {
  const text = String(value || '').trim();
  if (!/^[A-Z][A-Z0-9]*(_[A-Z0-9]+)*$/.test(text) || ABBREVIATIONS.has(text)) return text;
  // A single letter is a tranche letter (Term loan B), not a word.
  const words = text.split('_').map(word => (ABBREVIATIONS.has(word) || word.length === 1 ? word : word.toLowerCase())).join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};
